import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorService } from '@deltager/organizers/admin/shared/error-handler/error-service';


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 400 && error.error?.errors) {
          // Handle FluentValidation errors
          this.errorService.handleValidationErrors(error.error.errors);
        } else {
          // Handle other types of errors
          this.errorService.handleError(error);
        }
        return throwError(() => error);
      })
    );
  }
}
